/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "categories": {
        "cardinal": ["one", "other"],
        "ordinal": ["other"]
      },
      "fn": function fn(n, ord) {
        var s = String(n).split('.'),
            i = s[0],
            f = s[1] || '',
            v0 = !s[1],
            i10 = i.slice(-1),
            f10 = f.slice(-1);
        if (ord) return 'other';
        return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
      }
    },
    "locale": "ceb"
  });
}